export const CHART_COLORS = {
    COLOR1: '#378EFF',
    COLOR2: '#00B74F',
    COLOR3: '#C1AA00',
    COLOR4: '#DB9200',
    COLOR5: '#465468',
}
